import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DragScrollDirective } from '../directives/drag-scroll.directive';
import { RoundDirective } from '../directives/round.directive';
import { AmusementComponent } from './amusement/amusement.component';
import { AuthLoginComponent } from './auth/login/login.component';
import { AuthLogoutComponent } from './auth/logout/logout.component';
import { GameCardComponent } from './game/game-card/game-card.component';
import { GameSearchComponent } from './game/game-search/game-search.component';
import { ButtonComponent } from './shared/button/button.component';
import { HeaderComponent } from './shared/header/header.component';
import { LoadingModalComponent } from './shared/loading-modal/loading-modal.component';
import { LocaleSelectorComponent } from './shared/locale-selector/locale-selector/locale-selector.component';
import { ModalComponent } from './shared/modal/modal.component';
import { UserbalanceComponent } from './user/userbalance/userbalance.component';
import { UsernameComponent } from './user/username/username.component';

const BASE_MODULE = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  OverlayModule,
  PlatformModule
];

const DIRECTIVES = [DragScrollDirective, RoundDirective];

const COMPONENTS = [
  AmusementComponent,
  AuthLoginComponent,
  AuthLogoutComponent,
  GameCardComponent,
  GameSearchComponent,
  ButtonComponent,
  HeaderComponent,
  LoadingModalComponent,
  ModalComponent,
  UserbalanceComponent,
  UsernameComponent,
  LocaleSelectorComponent,
];

@NgModule({
  imports: [...BASE_MODULE],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...BASE_MODULE, ...COMPONENTS, ...DIRECTIVES]
})
export class SharedModule {}
